import React from 'react';
import { m } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
export function AboutAuthor() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-21" data-mp="2hf4lkrab19s1">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-22" data-mp="2m9h3gww4ud1o">
        <div className="mb-6 text-center" data-id="element-23" data-mp="2q9ri0xxzqbs5">
          <SectionTag icon="🏐" data-id="element-24" data-mp="2q8hkc9v1v5m1">Acerca de Sesión en Mano</SectionTag>
        </div>

        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="rounded-3xl border border-gris-claro bg-bg-secondary p-8 text-center shadow-card sm:p-10" data-id="element-25" data-mp="1tka8g7vw05l6">
          <QuoteIcon size={28} className="mx-auto text-azul" data-id="element-26" data-mp="27jjjyu95ebit" />
          <p className="mt-4 text-lg italic leading-relaxed text-gris-oscuro sm:text-xl" data-id="element-27" data-mp="3dzdkbu9nt74d">
            "He volcado en este sistema los esquemas reales que utilizamos para transformar entrenamientos
            improvisados en sesiones con criterio profesional. Menos búsqueda en YouTube y más voleibol
            real en la pista."
          </p>
          <div className="mx-auto mt-6 max-w-xl border-t border-gris-claro pt-4" data-id="element-28" data-mp="25tjqf7vmfn3r">
            <p className="font-heading text-base font-semibold text-azul-dark" data-id="element-29" data-mp="20scgp39x4dug">El Equipo de VOLEY-PRO 360</p>
            <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-30" data-mp="1vt0zjt5n36cc">
              Entrenadores del voleibol base español con más de una década de experiencia en cantera.
              Formados en la pista pequeña, en el vestuario ruidoso y en la reunión de padres difícil. Todo
              lo que encontrarás en VOLEY-PRO 360 viene de ahí. No de la teoría. De la pista real.
            </p>
          </div>
        </m.div>
      </div>
    </section>;
}